import { IconButton, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconButton: {
      marginRight: theme.spacing(2),
    },
  })
)

export const BrandLink = () => {
  const navigate = useNavigate()
  const classes = useStyles()
  const handleHome = () => navigate('/')

  return (
    <IconButton
      onClick={handleHome}
      edge="start"
      className={classes.iconButton}
      color="inherit"
      size="large"
    >
      <HomeIcon />
    </IconButton>
  )
}
